import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';

const ImpersonationFrame = () => {
  const theme = useTheme();

  return (
    <Box
      aria-hidden="true"
      data-test-id="impersonation-frame"
      sx={{
        position: 'fixed',
        inset: 0,
        outline: `3px solid ${theme.semantic.elevatedState}`,
        outlineOffset: '-3px',
        pointerEvents: 'none',
        zIndex: theme.zIndex.modal - 1,
      }}
    >
      <Box
        sx={{
          position: 'fixed',
          left: '50%',
          bottom: 0,
          transform: 'translateX(-50%)',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          height: '20px',
          px: '12px',
          borderRadius: '6px 6px 0 0',
          backgroundColor: theme.semantic.elevatedState,
          color: theme.semantic.elevatedStateInk,
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '.04em',
          textTransform: 'uppercase',
        }}
      >
        <VisibilityOutlined sx={{ fontSize: '12px' }} />
        {t('page_headings.impersonating_badge')}
      </Box>
    </Box>
  );
};

export default ImpersonationFrame;
